import AutoLogout from 'AutoLogout'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Theme } from 'components/Theme'
import { authApi } from 'features/auth/authApi'
import { Router } from 'pages/Router'
import { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'styles.css'
import { SWRConfig } from 'swr'
declare global {
  interface Window {
    keycloakInitialized: boolean
  }
}

const App = () => {
  const [authenticated, setAuthenticated] = useState<boolean>(false)
  const [token, setToken] = useState('')

  useEffect(() => {
    if (!authenticated && !token) {
      if (!window.keycloakInitialized) {
        authApi.initKeycloak((token) => {
          setAuthenticated(true)
          setToken(token!)
        })
        window.keycloakInitialized = true
      }
    }
  }, [authenticated, token])

  return (
    <BrowserRouter data-testid="browserRouterWrapper">
      <Theme data-testid="themeWrapper">
        <AutoLogout />
        <SWRConfig
          data-testid="swrConfigWrapper"
          value={{
            shouldRetryOnError: false,
            revalidateOnFocus: false,
          }}
        >
          <ToastContainer position="top-right" autoClose={10000} data-testid="toastContainer" />
          <Router authenticated={authenticated} token={token} />
        </SWRConfig>
      </Theme>
    </BrowserRouter>
  )
}

export default App
